import tgAxios from "@/api/api-axios";
import { Track } from "livekit-client";

export const muteParticipantMeeting = async (
  id: string,
  payload: {
    participantIdentity: string;
    trackType: Track.Kind;
    muted: boolean;
  }
) => {
  return tgAxios.post(`/meetings/${id}/participants/mute`, payload);
};
export const muteAllParticipantMeeting = async (
  id: string,
  payload: {
    trackType: Track.Kind;
    muted: boolean;
  }
) => {
  return tgAxios.post(`/meetings/${id}/all-participants/mute`, payload);
};
export const remoteParticipantMeeting = async (
  id: string,
  payload: { participantIdentity: string }
) => {
  return tgAxios.post(`/meetings/${id}/participants/remove`, payload);
};
export const joinMeetingApi = async (id: string) => {
  return tgAxios.post(`/meetings/${id}/join`);
};
export const getMeetingByCodeApi = async (code: string) => {
  return tgAxios.get(`/meetings/get-by-code/${code}`);
};
export const endMeetingApi = async (id: string) => {
  const response = await tgAxios.patch(`/meetings/end/${id}`);
  window.dispatchEvent(new CustomEvent('meeting-ended', {detail: {id}}));
  return response;
};

export interface UpdateParticipantPayload {
  addCoHost?: string[];
  removeCoHost?: string[];
  addCanShare?: string[];
  removeCanShare?: string[];
  allowAllShare?: boolean;
  disallowAllShare?: boolean;
  clearAllRaiseHand?: boolean;

}

export interface UpdateRaiseHandPayload {
  addRaiseHand?: string[];
  removeRaiseHand?: string[];
}

export const updateRaiseHandMeeting = async (
  meetingId: string,
  payload: UpdateRaiseHandPayload
): Promise<{ currentRaisedHands: string[] }> => {
  const response = await tgAxios.patch<{ currentRaisedHands: string[] }>(
    `/meetings/raise-hand/${meetingId}`,
    payload
  );
  return response.data;
};



export const updateParticipantMeeting = async (
  meetingId: string,
  payload: UpdateParticipantPayload
): Promise<{currentRaisedHands: string[]; currentCoHosts: string[]; currentCanShare: string[]}> => {
  const response = await tgAxios.patch<{currentRaisedHands: string[]; currentCoHosts: string[]; currentCanShare: string[]}>(
    `/meetings/update-participant/${meetingId}`,
    payload
  );
  return response.data;
};

// Gain is a capture level (0..100), independent of microphone mute/unmute.
export const updateMeetingMicrophoneVolume = (meetingId: string, imei: string, microphoneVolume: number) =>
  tgAxios.post(`/mqtt/set-microphone-volume/${encodeURIComponent(imei)}/${encodeURIComponent(meetingId)}`, {microphoneVolume});

export interface AvailableMeetingDevice {
  id: string;
  deviceName: string;
  imei: string;
  connectionStatus: string;
  isInMeeting?: boolean;
}
export const getAvailableMeetingDevices = (meetingId: string): Promise<{data: AvailableMeetingDevice[]}> =>
  tgAxios.get(`/meetings/${meetingId}/available-devices`);
export const addMeetingDevices = (meetingId: string, deviceIds: string[]) =>
  tgAxios.post(`/meetings/${meetingId}/devices`, {deviceIds});

export interface MeetingPeripheralSettings {
  camDefault?: string;
  micDefault?: string;
  speakerDefault?: string;
  resolutionCam?: string;
  fpsCam?: number;
}
export interface MeetingDeviceSettings {
  imei: string;
  deviceName: string;
  peripheralsUpdatedAt?: string;
  cameraDevices: {id: string; name: string}[];
  microphoneDevices: {id: string; name: string}[];
  speakerDevices: {id: string; name: string}[];
  settings: MeetingPeripheralSettings;
}
const deviceSettingsUrl = (meetingId: string, imei: string) =>
  `/mqtt/setting-device-on-meeting/${encodeURIComponent(imei)}/${encodeURIComponent(meetingId)}`;
export const getMeetingDeviceSettings = (meetingId: string, imei: string): Promise<{data: MeetingDeviceSettings}> =>
  tgAxios.get(deviceSettingsUrl(meetingId, imei));
export const updateMeetingDeviceSettings = (meetingId: string, imei: string, settings: MeetingPeripheralSettings) =>
  tgAxios.post(deviceSettingsUrl(meetingId, imei), settings);

export const updateCameraResolution = (meetingId: string, resolution: string | undefined, target?: {identity?: string; deviceImei?: string}, fps?: number) =>
  tgAxios.post(`/meetings/${encodeURIComponent(meetingId)}/camera-resolution`, {resolution, fps, ...target});
